import { createSlice } from "@reduxjs/toolkit";

const userCars = createSlice({
    name: "userCars",
    initialState: {
        singleCar: null,
        singleCarLoaded: false,
        cars: [],
        dataLoaded: false,
        activeRequests: [],
        activeRequestsLoaded: false,
        unActiveRequests: [],
        unActiveRequestsLoaded: false,
        singleRequest: null,
        singleRequestLoaded: false,
        partOffers: [],
        partOffersLoaded: false
    },
    reducers: {
        getCar(state, _action) {
            return { ...state, singleCarLoaded: false }
        },
        setCar(state, action) {
            const carData = action.payload
            return { ...state, singleCar: carData, singleCarLoaded: true };
        },
        createUserCar(state, _action) {
            return { ...state, isLoaded: false }
        },
        getCars(state, _action) {
            return { ...state, dataLoaded: false };
        },
        setCars(state, action) {
            const carData = Object.values(action.payload);
            return { ...state, cars: carData, dataLoaded: true };
        },
        getActiveRequests(state, _action) {
            return { ...state, activeRequestsLoaded: false }
        },
        setActiveRequests(state, action) {
            const requestData = Object.values(action.payload);

            return {
                ...state,
                activeRequests: requestData[1],
                count: requestData[0],
                activeRequestsLoaded: true,
            }
        },
        getUnActiveRequests(state, _action) {
            return { ...state, unActiveRequestsLoaded: false }
        },
        setUnActiveRequests(state, action) {
            const requestData = Object.values(action.payload);

            return {
                ...state,
                unActiveRequests: requestData[1],
                unActiveCount: requestData[0],
                unActiveRequestsLoaded: true,
            }
        },
        getSingleRequest(state, _action) {
            return { ...state, singleRequestLoaded: false }
        },
        setSingleRequest(state, action) {
            const requestData = action.payload
            return { ...state, singleRequest: requestData, singleRequestLoaded: true };
        },
        getPartOffers(state, _action) {
            return { ...state, partOffersLoaded: false }
        },
        setPartOffers(state, action) {
            const requestData = Object.values(action.payload);

            return {
                ...state,
                partOffers: requestData[1],
                partOffersCount: requestData[0],
                partOffersLoaded: true,
            }
        },
    },
});

export const {
    getCars,
    setCars,
    getCar,
    setCar,
    getActiveRequests,
    setActiveRequests,
    getUnActiveRequests,
    setUnActiveRequests,
    getSingleRequest,
    setSingleRequest,
    getPartOffers,
    setPartOffers,
    createUserCar,
} = userCars.actions;

export default userCars.reducer;
